import { render, staticRenderFns } from "./SizeInformationParameterCreateOrUpdate.vue?vue&type=template&id=9f57b670&"
import script from "./SizeInformationParameterCreateOrUpdate.vue?vue&type=script&lang=js&"
export * from "./SizeInformationParameterCreateOrUpdate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports